import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { map } from "rxjs/operators";
import { ClientService } from "src/app/core/admin/_services/client.service";
import { Section } from '../../draggable/types'
import { ComponentStore } from "@ngrx/component-store";
import { defaultSections } from "../toe-report-template-edit/default-structure";
import { DraggableComponent } from '../../draggable/draggable.component'
import { StoreToeReportTemplatePayload } from "../toe-report-template.service";
import { BehaviorSubject } from "rxjs";

export interface ToeReportTemplateFormValues {
  name: string,
  client_id: number,
  cover_page_included: boolean,
  toc_included: boolean,
  back_page_included: boolean,
  cover_page_title: string,
  client_id_included: boolean,
  assignment_id_included: boolean,
  toe_id_included: boolean,
  toe_id_label: string,
  date_of_instruction_included: boolean,
  footer_module_included: boolean
}

@Component({
  selector: 'kt-toe-report-template-form',
  templateUrl: './toe-report-template-form.component.html',
  styleUrls: ['./toe-report-template-form.component.scss'],
  providers: [ComponentStore]
})
export class ToeReportTemplateFormComponent {
  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    client_id: new FormControl(-1),
    cover_page_included: new FormControl(true),
    cover_page_title: new FormControl('Terms of Engagement'),
    client_id_included: new FormControl(true),
    assignment_id_included: new FormControl(true),
    toe_id_included: new FormControl(true),
    toe_id_label: new FormControl('ToE ID'),
    date_of_instruction_included: new FormControl(true),
    footer_module_included: new FormControl(true),
    toc_included: new FormControl(true),
    back_page_included: new FormControl(true),
  })

  private _sections$ = new BehaviorSubject<Section[]>([])
  sections$ = this._sections$.asObservable()
  @Input()
  set sections(value: Section[]) {
    this._sections$.next(value)
  }

  @Input()
  set formValue(value: ToeReportTemplateFormValues) {
    if (value === undefined) return;
    this.form.patchValue({
      ...value,
      client_id: value.client_id ?? -1
    })
  }

  @Output() sectionsChanged = new EventEmitter<Section[]>()

  @ViewChild(DraggableComponent) draggableComponent: DraggableComponent;

  clients$ = this.clientService.fetchListing().pipe(
    map(clients => {
      return clients.map(client => ({
        id: client.id,
        name: client.type === 'Company' ? client.name : `${client.name} ${client.last_name}`
      }))
    })
  )

  constructor(
    private clientService: ClientService
  ) {}

  onSectionsChanged(sections: Section[]) {
    this.sectionsChanged.emit(sections)
  }
  onNewSectionClick() {
    this.draggableComponent?.addNewSection()
  }
  onResetSections() {
    this.draggableComponent?.resetSections(defaultSections)
    this.form.patchValue({
      cover_page_included: true,
      toc_included: true,
      back_page_included: true
    })
  }

  validate() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(controlName => {
        if (this.form.controls[controlName].invalid) {
          this.form.controls[controlName].markAsTouched()
        }
      })
      return 'invalid'
    }
    return 'success'
  }

  preparePayload(sections: Section[]): StoreToeReportTemplatePayload {
    return {
      name: this.form.controls.name.value,
      cover_page_included: this.form.controls.cover_page_included.value,
      toc_included: this.form.controls.toc_included.value,
      back_page_included: this.form.controls.back_page_included.value,
      sections: sections,
      cover_page_title: this.form.controls.cover_page_title.value,
      client_id_included: this.form.controls.client_id_included.value,
      assignment_id_included: this.form.controls.assignment_id_included.value,
      toe_id_included: this.form.controls.toe_id_included.value,
      toe_id_label: this.form.controls.toe_id_label.value,
      date_of_instruction_included: this.form.controls.date_of_instruction_included.value,
      footer_module_included: this.form.controls.footer_module_included.value,
      client_id: this.form.controls.client_id.value === -1
        ? null
        : this.form.controls.client_id.value
    }
  }
}